/**
 * SDK Design Tokens — shared constants for consistent styling across all controls.
 *
 * These are the single source of truth for visual properties used by SDK components.
 * Editor-specific constants (like GENERATIVE_PRESETS or GRADIENT_BASE_TONES) stay
 * in their own constant files — this file only contains cross-cutting UI tokens.
 */

/* ── Toggle sizes ── */
export const TOGGLE_SIZES = {
  md: {
    track: 'w-9 h-5',
    thumb: 'w-4 h-4',
    thumbOffset: 'left-0.5 top-0.5',
    thumbTranslate: 'peer-checked:translate-x-4',
  },
  sm: {
    track: 'w-8 h-[18px]',
    thumb: 'w-3 h-3',
    thumbOffset: 'left-0.5 top-[3px]',
    thumbTranslate: 'peer-checked:translate-x-3.5',
  },
};

/* ── Common slider thumb styles ── */
export const SLIDER_THUMB_CLS = `
  [&::-webkit-slider-thumb]:appearance-none
  [&::-webkit-slider-thumb]:rounded-full
  [&::-webkit-slider-thumb]:bg-white
  [&::-webkit-slider-thumb]:cursor-grab
  [&::-webkit-slider-thumb]:shadow-md
  [&::-webkit-slider-thumb]:active:cursor-grabbing
  [&::-moz-range-thumb]:rounded-full
  [&::-moz-range-thumb]:bg-white
  [&::-moz-range-thumb]:border-0
  [&::-moz-range-thumb]:cursor-grab
  [&::-moz-range-thumb]:shadow-md`;

/* ── Standard range slider (SliderRow) ── */
export const RANGE_SLIDER_CLS = `flex-1 h-1.5 appearance-none bg-white/10 rounded-full cursor-pointer slider-thumb-concentric-sm`;

/* ── Stepped slider (DarkenSlider) — transparent background, overlays dots ── */
export const STEPPED_SLIDER_CLS = `absolute inset-0 w-full h-full appearance-none bg-transparent cursor-pointer slider-thumb-concentric`;

/* ── Text styling tokens ── */
export const TEXT = {
  sectionLabel: 'module-subheader',
  fieldLabel: 'module-subheader',
  tinyLabel: 'text-[9px] text-white/35',
  value: 'text-[10px] text-white/50 tabular-nums',
  heading: 'module-header',
  hint: 'module-desc',
};

/* ── Active/inactive button token ── */
export const BUTTON_ACTIVE = 'border-white/25 bg-white/10 text-white/90';
export const BUTTON_INACTIVE = 'border-white/8 bg-white/[0.02] text-white/45 hover:bg-white/[0.06] hover:text-white/65';

/* ── Swatch selection states ── */
export const SWATCH_ACTIVE = 'border-white/40 scale-110';
export const SWATCH_INACTIVE = 'border-white/10 hover:border-white/25';
